import ApiService from "../service/ApiService";

let moduleApi = {};
let moduleName = "diem_den_an_toan";

moduleApi.list = (dataFilter) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter,
  };
  return ApiService(api);
};

moduleApi.clearCache = () => {
  ApiService.clearCache(new RegExp("/" + moduleName + "s([/?#].*)?$"));
};

moduleApi.findById = (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: { id: id },
  };
  return ApiService(api);
};

moduleApi.updateUuDai = (dataForm) => {
  let api = {
    module: moduleName,
    type: "update_uu_dai",
    value: dataForm,
    message: {
      success: "Cập nhật thành công", //string | null | comment
      error: "Cập nhật không thành công", //string | null | comment
    },
  };
  return ApiService(api);
};

moduleApi.updateHdvUuDai = (dataForm) => {
  let api = {
    module: moduleName,
    type: "update_hdv_uu_dai",
    value: {
      body: dataForm,
    },
    message: {
      success: "Cập nhật thành công", //string | null | comment
      error: "Cập nhật không thành công", //string | null | comment
    },
  };
  return ApiService(api);
};

moduleApi.updateAlbumImage = (dataForm) => {
  let api = {
    module: moduleName,
    type: "update_album_image",
    value: dataForm,
    message: {
      success: "Cập nhật thành công", //string | null | comment
      error: "Cập nhật không thành công", //string | null | comment
    },
  };
  return ApiService(api);
};

export default moduleApi;
